/*
 * @Author: BoomZhang(ivanszmb@gmail.com) 
 * @Date: 2025-08-21 10:04:35 
 * @Last Modified by:   BoomZhang 
 * @Last Modified time: 2025-08-21 10:04:35 
 */
if (!customElements.get('tab-list')) {
  class tabList extends HTMLElement {
    constructor() {
      super()
      this.listTab=this.querySelectorAll('.item')
      this.listTabContent=this.querySelectorAll('.item-image')
      this.listTab.forEach((item,index)=>{
        item.addEventListener('click',()=>{
          this.toggleActiveTab(index)
          window.dataLayer = window.dataLayer || [];
          dataLayer.push({
            event: 'tab_click',
            tab_name: item.getAttribute('data-title')
          });
        })
      })
    }
    toggleActiveTab(index){
      this.listTab.forEach((item, cindex) => {
        item.classList.remove('active')
      })
      this.listTabContent.forEach((item, cindex) => {
        item.classList.remove('active')
      })
      this.listTab[index].classList.add('active')
      // 设置当前 active
      const activeTab = this.listTab[index]
      const activeContent = this.listTabContent[index]

      if (activeTab) {
        activeTab.classList.add('active')
        activeTab.scrollIntoView({
          behavior: 'smooth',  
          block: 'nearest',    
          inline: 'center'    
        })
      }
      this.listTabContent[index].classList.add('active')
    }
  }
  
  customElements.define('tab-list', tabList);
}
